import { commentSchema } from '@/models/commentSchema';
import { pageableSchema } from '@/models/pageableSchema';
import { apiPath } from '@/redux/apiPath';
import { axiosInstanceNewAPI } from '@/services/api/utils/axiosInstance';
import { ThunkConfig } from '@/types/store';
import { validateDataUsingZodSchema } from '@/utils/validateDataUsingZodSchema';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Comment, NewReaction } from '@/types/models';
import { z } from 'zod';
import { GetElementProps } from '@/redux/comment/comment.types';
import { getError } from '@/utils/error-report/getError';
import { newReactionSchema } from '@/models/newReactionSchema';
import { PROJECT_ID } from '@/constants';
import type { AppDispatch, RootState } from '@/redux/store';
import { currentModelIdSelector } from '@/redux/models/models.selectors';

export const getComments = createAsyncThunk<
  Comment[],
  void,
  { dispatch: AppDispatch; state: RootState } & ThunkConfig
>('project/getComments', async (_, { getState }) => {
  try {
    const modelId = currentModelIdSelector(getState());
    const response = await axiosInstanceNewAPI.get(apiPath.getMapComments(PROJECT_ID, modelId));

    const isDataValid = validateDataUsingZodSchema(response.data, pageableSchema(commentSchema));

    return isDataValid ? response.data.content : [];
  } catch (error) {
    return Promise.reject(getError({ error }));
  }
});

export const getCommentReaction = createAsyncThunk<
  NewReaction | null,
  GetElementProps,
  ThunkConfig
>('project/getCommentReaction', async ({ elementId, modelId }) => {
  try {
    const response = await axiosInstanceNewAPI.get<NewReaction>(
      apiPath.getReaction(modelId, elementId),
    );

    const isDataValid = validateDataUsingZodSchema(response.data, z.array(newReactionSchema));

    return isDataValid ? response.data : null;
  } catch (error) {
    return Promise.reject(getError({ error }));
  }
});
